@if (!isSiteUnderConstruction) {
  <div
    class="main-holder"
    infiniteScroll
    [infiniteScrollDistance]="2"
    [infiniteScrollThrottle]="50"
    (scrolled)="onScrollDown()"
    [scrollWindow]="false"
    [ngClass]="siteData.className"
    >
    @if(!isResumePreview){
      <app-header />
    }
    <app-not-verified />
    <router-outlet />
    @if (!isSignUpQuestions) {
      <app-footer />
    }
  </div>
}

@if (isSiteUnderConstruction) {
  <div class="site-under-construction">
    <img alt="site-under-construction" [src]="siteData.mobileLogo" /><br />
    <h1>Site Under construction.</h1>
    <p>
      We are currently working on the site to bring you a better experience.
      Please check back later.
    </p>
  </div>
}

<ngx-ui-loader [fgsColor]="preloader.fgsColor"
  [fgsPosition]="preloader.fgsPosition"
  [fgsSize]="preloader.fgsSize"
  [fgsType]="preloader.fgsType"
  [bgsColor]="preloader.bgsColor"
  [bgsOpacity]="preloader.bgsOpacity"
  [bgsPosition]="preloader.bgsPosition"
  [bgsSize]="preloader.bgsSize"
  [bgsType]="preloader.bgsType"
  [gap]="preloader.gap"
  [logoPosition]="preloader.logoPosition"
  [logoSize]="preloader.logoSize"
  [logoUrl]="preloader.logoUrl"
  [overlayColor]="preloader.overlayColor"
  [pbColor]="preloader.pbColor"
  [pbDirection]="preloader.pbDirection"
  [pbThickness]="preloader.pbThickness"
  [hasProgressBar]="preloader.hasProgressBar"
  [text]="preloader.text"
  [textColor]="preloader.textColor"
  [textPosition]="preloader.textPosition"
 />
